import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import ListItemText from '@mui/material/ListItemText'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'

interface FilterProps {
  name: string
  data: string[]
  filteredData: string[]
  error?: string | null
  loading?: boolean | undefined
  filterAddCallback: (v: string[]) => void
}

export default function FilterInput(props: FilterProps) {
  const { data, filteredData, name, filterAddCallback, loading, error } = props

  const handleChangeWorkout = (
    event: SelectChangeEvent<typeof filteredData>
  ) => {
    const {
      target: { value },
    } = event
    filterAddCallback(data.filter((d) => value.includes(d)))
  }

  return (
    <FormControl sx={{ marginRight: 1}}>
      <Select
        multiple
        sx={{
          height: 35,
          fontWeight: filteredData.length > 0 ? 500 : 400,
          borderStyle: filteredData.length > 0 ? "groove" : "inherit",
          fontSize: 14,
        }}
        variant="outlined"
        value={filteredData}
        onChange={handleChangeWorkout}
        displayEmpty
        renderValue={(selected) => {
          let label = name
          if (selected.length > 0) label = label + ' (' + selected.length + ')'
          return label
        }}
      >
        {!error &&
          !loading &&
          data.map((d) => (
            <MenuItem value={d} key={d}>
              <Checkbox checked={filteredData.indexOf(d) > -1} />
              <ListItemText primary={d} />
            </MenuItem>
          ))}
        {error && (
          <MenuItem value={error} key={'error'}>
            <ListItemText primary={error} sx={{ color: 'gray' }} />
          </MenuItem>
        )}
        {loading && (
          <MenuItem value={'loading'} key={'loading'}>
            <ListItemText primary={'Loading...'} sx={{ color: 'gray' }} />
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}
